import { render, staticRenderFns } from "./PeriodicalResult.vue?vue&type=template&id=177895da&scoped=true"
import script from "./PeriodicalResult.vue?vue&type=script&lang=js"
export * from "./PeriodicalResult.vue?vue&type=script&lang=js"
import style0 from "./PeriodicalResult.vue?vue&type=style&index=0&id=177895da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177895da",
  null
  
)

export default component.exports